import React from 'react';
import { makeStyles, Pagination } from "../../../../index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        flex: '0 0 auto',
        zIndex: 5,
        paddingTop: theme.spacing(2),
        height: 64,
    },
}); });
export var NoteSelectDialogToolbar = function (props) {
    var pagination = props.pagination, onChangePagination = props.onChangePagination;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Pagination, { page: pagination.page, lastPage: pagination.lastPage, onChange: onChangePagination })));
};
